import { Box } from '@mui/material';
import React from 'react';
import StunCompScss from './StunComp.module.scss';


function StunComp(props) {
    return (
        <div>
            <Box className={StunCompScss.stunningFootImage}>
                <img src={props.img} alt={props.img} />
                <Box className={StunCompScss.stunningFootImageGradient}>
                    <h6>{props.head}</h6>
                    <p>{props.content}</p>
                </Box>
            </Box>
        </div>
    )
}

export default StunComp;
